import Constants from './Constants'
import NotifyActions from './NotifyActions'
import ItemActions from './ItemActions'

const STATUS = Constants.GET_SCRIPTS_STATUS
const GET = Constants.GET_SCRIPTS
const GET_ONE = Constants.GET_SCRIPT
const ADD = Constants.ADD_SCRIPT
const REMOVE = Constants.REMOVE_SCRIPT
const UPDATE = Constants.UPDATE_SCRIPT

const LOGS_STATUS = Constants.GET_SCRIPT_LOGS_STATUS
const LOGS_GET = Constants.GET_SCRIPT_LOGS

const options = { 
  parentName : 'project', 
  itemsName : 'scripts',
  actionTypeBase : 'SCRIPT', 
  parentIdKey : 'projectId', 
  humanItemName : 'Script',
  notify : {
    create : true,
    add : true,
    remove : true,
    update : true
  }
}

const actions = ItemActions.create( options )

function deploy( parent, item ) {
  return ( dispatch, getState, api ) => {
    const req = api.script( item ).deploy()
    return req
      .then( ( data ) => {
        dispatch( { type : UPDATE, itemId : typeof item === 'string' ? item : item.id, item : data } )
      } )
      .catch( ( err ) => {
        dispatch( NotifyActions.requestError( `Failed to Deploy ${options.humanItemName}`, err ) )
      } ) 
  }
}

function undeploy( parent, item ) {
  return ( dispatch, getState, api ) => {
    const req = api.script( item ).undeploy()
    return req
      .then( ( data ) => {
        dispatch( { type : UPDATE, itemId : typeof item === 'string' ? item : item.id, item : data } )
      } )
      .catch( ( err ) => {
        dispatch( NotifyActions.requestError( `Failed to Undeploy ${options.humanItemName}`, err ) )
      } ) 
  }
}

function logs( parent, item, options ) {
  return ( dispatch, getState, api ) => {

    dispatch( { type : LOGS_STATUS, status : Constants.STATUS_LOADING, statusMessage : null } )
    return api.script( item ).logs( options )
      .then( ( data ) => {
        dispatch( { 
          type : LOGS_GET,
          scriptId : typeof item === 'string' ? item : item.id,
          total : data.items.length,
          ...data
        } )
      } )
      .catch( ( x ) => {
        dispatch( NotifyActions.requestError( `Failed to get Logs for script ${item.id || item}`, x ) )
        dispatch( { type : LOGS_STATUS, status : Constants.STATUS_ERROR } )
      } )
  }
}

function metrics( parent, item, options ) {

}

module.exports = Object.assign( actions, {
  deploy,
  undeploy,
  logs,
  metrics
} )
